/**
 * @param {String} [href]
 * @constructor
 */
function Url(href) {
	this.href = href ? Url.normalize(href) : Url.get();
	this._path = this.href.split('#')[0].split('?')[0].split('/');
	this._path.shift();
	this.before = '';
	this.current = this._path[0];
	/** @type {Get} get */
	this.get = new Get(this.href);
}

Url.prototype.shift = function () {
	this.before = this._path.shift() || '';
	this.current = this._path[0] || '';
	return this.before;
};

Url.prototype.shiftTill = function (v) {
	while (true) {
		if (this.current === v || !this._path.length) {
			break;
		}
		this.shift();
	}
};

Url.makeUrl = function (el) {
	el = el || location;
	if (el.tagName === 'A') { // IE fix
		el['href'] = el.href;
	}
	return (el.pathname[0] === '/' ? '' : '/') + el.pathname + (el.search ? el.search : '') + (el.hash ? el.hash : '');
};

Url.get = function () {
	if (location.hash.indexOf('!') === 1) {
		return location.hash.substr(2);
	}
	return Url.makeUrl();
};

Url.set = function (href) {
	if (history.pushState) {
		history.pushState(null, '', href);
		return;
	}
	location.hash = '!' + href;
};

Url.replace = function (href) {
	if (history.replaceState) {
		history.replaceState(null, '', href);
		return;
	}
	location.replace('#!' + href);
};

Url.normalize = function (url) {
	let el = document.createElement('a');
	if (history.pushState || url[0] === '/') {
		el.href = url;
	} else {
		let a = Url.get().split('/');
		a.splice(a.length - 1, 1);
		el.href = a.join('/') + '/' + url;
	}
	return this.makeUrl(el);
};